import { httpApi } from '@app/api/http.api';
import {
  User,
  CreateUserDto,
  UpdateUserDto,
  ChangePasswordDto,
  UserPaginatedResponse,
  PaginationParams,
} from '@app/types/api.types';

export const createUser = (data: CreateUserDto): Promise<User> =>
  httpApi.post<User>('/users', data).then(({ data }) => data);

export const getUsers = (params?: PaginationParams): Promise<UserPaginatedResponse> =>
  httpApi
    .get<UserPaginatedResponse>('/users', { params })
    .then(({ data }) => data);

export const getUserById = (id: string): Promise<User> =>
  httpApi.get<User>(`/users/${id}`).then(({ data }) => data);

export const updateUser = (id: string, data: UpdateUserDto): Promise<User> =>
  httpApi.patch<User>(`/users/${id}`, data).then(({ data }) => data);

export const deleteUser = (id: string): Promise<void> =>
  httpApi.delete<void>(`/users/${id}`).then(() => undefined);

export const changePassword = (id: string, data: ChangePasswordDto): Promise<void> =>
  httpApi.patch<void>(`/users/${id}/password`, data).then(() => undefined);

